module.exports = __webpack_public_path__ + "media/SuiteApp/assets/svg/img/captions-a3c2b291fc41ad3739c01a80270a48e9.svg";